import {
    ESTADO_CHANGE_PAGINA,
    ESTADO_CHANGE_CONEXION,
    ESTADO_CHANGE_PERSONAL,
    PAGE_PRINCIPAL,
    PAGE_MARCAJE, PAGE_MARCAJERESULTADO,
    ESTADO_DESCONECTADO, CONEXION_DESCONECTADO, estadoChangeConexion,
} from './actions'



let initialState = {
    pagina: PAGE_MARCAJE,
    conexion: CONEXION_DESCONECTADO,
    personal: null,
}

export const estado = (state = initialState, action) => {
    switch (action.type) {
        case ESTADO_CHANGE_PAGINA:
            return changePagina(state, action.newPagina);
        case ESTADO_CHANGE_CONEXION:
            return changeConexion(state, action.newConexion);
        case ESTADO_CHANGE_PERSONAL:
            return changePersonal(state, action.newPersonal);
        default:
            return state;
    }
}


const changePagina = (state, newPagina) => {
    return { ...state, pagina: newPagina };
}

const changeConexion = (state, newConexion) => {
    return { ...state, conexion: newConexion };
}

const changePersonal = (state, newPersonal) => {
    return { ...state, personal: newPersonal };
}
